@import '../../../theme.scss';

verdocs-contact-picker {
  display: block;
  border: 1px solid #ebebeb;
  background-color: $verdocs-grey-4;
  font-family: $verdocs-primary-font;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);

  form {
    gap: 12px;
    width: 300px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    background-color: $verdocs-grey-3;

    .row {
      gap: 8px;
      display: flex;
      position: relative;
      flex-direction: row;
      align-items: flex-start;

      .option {
        gap: 4px;
        display: flex;
        padding: 5px 8px;
        align-items: center;
        flex-direction: row;
        text-wrap: nowrap;
      }
    }

    .names-row {
      gap: 8px;
      display: flex;
      flex-direction: row;

      > input {
        font-size: 14px;
        width: 88px;
      }
    }

    .pin-code {
      gap: 8px;
      display: flex;
      align-items: flex-start;
      flex-direction: row;

      > input {
        flex: 0 0 197px;
        font-size: 14px;
        //margin-left: 88px;
      }
    }

    .address {
      gap: 8px;
      display: flex;
      align-items: center;
      flex-direction: row;

      > input {
        flex: 1;
        font-size: 14px;
        //margin-left: 88px;
      }
    }

    .zip-code {
      gap: 8px;
      display: flex;
      align-items: center;
      flex-direction: row;

      > input {
        flex: 1;
        font-size: 14px;
        //margin-left: 88px;
      }
    }

    label {
      display: flex;
      flex: 0 0 80px;
      font-size: 13px;
      font-weight: 500;
      color: $verdocs-bg-4;
    }

    .row.message textarea {
      width: 100%;
      padding: 5px 7px;
      border-radius: 4px;
      font-family: $verdocs-primary-font;
    }

    input {
      flex: 1;
      padding: 6px;
      font-size: 14px;
      border-radius: 3px;
      //background: #00000005;
      border: 1px solid $border-color-extralight;

      &:focus {
        outline: none;
      }
    }
  }

  .buttons {
    display: flex;
    column-gap: 6px;
    margin-top: 16px;
    flex-direction: row;

    .flex-fill {
      flex: 1;
    }
  }

  ::placeholder {
    color: $verdocs-bg-2;
  }

  // @see https://community.logmein.com/t5/LastPass-Support-Discussions/placeholder-text-overrides-data-lpignore-quot-true-quot/td-p/295135
  // LastPass is ignoring the data-lpignore attribute in some cases
  [data-lastpass-icon-root] {
    display: none !important;
  }
}

#verdocs-contact-picker-suggestions {
  .dropdown {
    max-height: 225px;
    overflow-y: scroll;
    background: #ffffff;
    font-family: $verdocs-primary-font;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);

    .suggestion {
      display: flex;
      padding: 6px 12px;
      align-items: center;
      flex-direction: row;

      svg {
        width: 32px;
        height: 32px;
      }

      .avatar {
        width: 32px;
        height: 32px;
        flex: 0 0 32px;
        margin-right: 8px;
        border-radius: 100%;
      }

      .details {
        display: flex;
        flex-direction: column;
      }

      .name {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 3px;
        color: $verdocs-grey-0;
      }

      .destination {
        font-size: 14px;
        margin-bottom: 3px;
        color: $verdocs-grey-1;
      }

      &:hover {
        background: #eee;
        cursor: pointer;
      }
    }
  }
}
